import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { reducer as oidcReducer } from "redux-oidc";
import createOidcMiddleware, { createUserManager } from "redux-oidc";
import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  HttpLink,
} from "apollo-boost";
import { authConfig } from "./AppCommon/auth";
import { loadLanguage } from "./Actions/languageActions";
import { keys, STATE_CULTURE } from "./Actions/stateActions";
import { busyReducer } from "./Reducers/busyReducer";
import { cookiesReducer } from "./Reducers/cookiesReducer";
import { configReducer } from "./Reducers/configReducer";
import { languageReducer } from "./Reducers/languageReducer";
import { cookiesMiddleware } from "./Middlewares/cookiesMiddleware";
import {
  httpMiddleware,
  httpDevMiddleware,
} from "./Middlewares/httpMiddleware";
import { promiseMiddleware } from "./Middlewares/promiseMiddleware";
import { thunkMiddleware } from "./Middlewares/thunkMiddleware";

const init = (config) => {
  const isDev = process.env.NODE_ENV === "development";
  const tokenManagerConfig = authConfig(config.auth, config.self);
  console.log("config.auth", tokenManagerConfig);
  const userManager = createUserManager(tokenManagerConfig);
  const oidcMiddleware = createOidcMiddleware(userManager);

  const reducers = combineReducers({
    busy: busyReducer,
    config: configReducer,
    oidc: oidcReducer,
    cookies: cookiesReducer(keys(), config),
    language: languageReducer,
  });

  const initialState = {
    config,
  };

  const middleware = applyMiddleware(
    promiseMiddleware,
    thunkMiddleware,
    oidcMiddleware,
    cookiesMiddleware,
    isDev ? httpDevMiddleware : httpMiddleware(config.api)
  );

  const devTool = window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : (f) => f;
  const enhancers = compose(middleware, devTool);
  const store = createStore(reducers, initialState, enhancers);
  console.log(config.graphql);
  const httpLink = new HttpLink({ uri: config.graphql });
  const authLink = new ApolloLink((operation, forward) => {
    const { oidc } = store.getState();
    const token = oidc.user && oidc.user.access_token;

    // Use the setContext method to set the HTTP headers.
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : "",
      },
    });

    return forward(operation);
  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink), // Chain it with the HttpLink
    cache: new InMemoryCache(),
  });
  console.log(authLink.concat(httpLink));
  userManager.events.addUserLoaded((user) => {
    console.log("UserLoaded", user);
  });

  userManager.events.addUserUnloaded(() => {
    console.log("UserUnloaded");
  });

  //TODO: Event reload configuration?
  store.dispatch({ type: "CONFIGURATION_LOADED", payload: config });

  var culture = store.getState().cookies[STATE_CULTURE];
  loadLanguage(culture, store.dispatch);

  return {
    store,
    client,
    userManager,
  };
};

export default init;
